import { useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

export default function QRScannerModal({ onDetected, onClose }) {
  useEffect(() => {
    const scanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 250 }, false);
    scanner.render(
      (decodedText) => {
        onDetected(decodedText.trim());
        scanner.clear();
      },
      () => {}
    );
    return () => { scanner.clear(); };
  }, [onDetected]);

  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
    <div className="w-full max-w-md rounded-2xl bg-slate-100 p-6 dark:bg-slate-900">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="font-semibold">Escanear QR del producto</h2>
        <button onClick={onClose} className="text-2xl text-slate-400 hover:text-white" aria-label="Cerrar">✕</button>
      </div>
      <div id="qr-reader" className="overflow-hidden rounded-xl" />
    </div>
  </div>;
}
